import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";

// Google Fonts 동적 로드 (개발 모드에서 더 안정적)
const loadGoogleFonts = () => {
  // 이미 로드되었는지 확인
  const existingLink = document.querySelector('link[href*="Material+Symbols+Outlined"]');
  if (existingLink) return;
  const link = document.createElement("link");
  link.href =
    "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,1,0&icon_names=stylus_fountain_pen";
  link.rel = "stylesheet";
  link.onload = () => {
    console.log("✅ Material Symbols Outlined 폰트 로드 완료");
  };
  link.onerror = () => {
    console.warn("❌ Material Symbols Outlined 폰트 로드 실패");  //폰트로드 제거?
  };
  document.head.appendChild(link);
};

// 폰트 로드 실행
loadGoogleFonts();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <App />
  </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
